<template>
    <div class="agreement">
        <Tabs value="0" @on-click="change_tab">
            <TabPane label="借款协议" name="0"></TabPane>
            <TabPane label="服务协议" name="1"></TabPane>
            <TabPane label="授权协议" name="2"></TabPane>
            <TabPane label="法律责任" name="3"></TabPane>
        </Tabs>
        <div id="editor"></div>
        <Form  :model="temp" :label-width="100">

            <FormItem>
                <Button type="primary" @click="doPost">提交</Button>
                <Button style="margin-left: 8px">取消</Button>
            </FormItem>
        </Form>
    </div>
</template>
<script>
let E = require("wangeditor");
export default {
    data() {
        return {
            formItem:{seal:""},
            temp:{},
            data:[],
            editor: null,
            active_tab:0,
            img_load:false
        };
    },
    mounted() {
        this.get_data();
    },
    methods: {
        get_data(){
            this.$get(this.$path.agreement).then(res => {
                if (res.data) {
                    this.data = res.data;
                    this.init_editor();
                } else {
                    this.$Message.error("获取数据失败");
                }
            });
        },
        init_editor() {
            this.editor = new E("#editor");
            this.editor.create();
            this.editor.txt.html(this.data[this.active_tab].content);
        },
        change_tab(name){
            this.active_tab = name;
            this.init_editor();
        },
        doPost(){
            this.data[this.active_tab].content = this.editor.txt.html();
            this.$post(this.$path.agreement,this.data[this.active_tab]).then(res => {
                if (res.success) {
                    this.$Message.success('提交成功');
                } else {
                    this.$Message.error(res.error);
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.ivu-form{
    margin-top: 20px;
}
.file_box {
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: 1px #eeeeee dashed;
    border-radius: 4px;
    img {
        width: 100%;
        height: 100%;
    }
    .img {
        width: 100%;
        height: 100%;
        p {
            text-align: center;
            color: #bab9b9;
            margin-top: 50px;
        }
    }
    input {
        position: absolute;
        top: 0;
        left: 0;
        width: 200px;
        height: 130px;
        opacity: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/system/agreement.vue